<template>
  <div
    ref="crumbItem"
    class="link-crumb-item"
    :class="{'crumb-root': isRoot, 'single-root': isLast}"
    :style="itemStyle"
    :index="getIndex"
  >
    <!-- 这里的标签一定要是span标签，方便计算长度 -->
    <span
      v-if="!isRoot"
      ref="sepreator"
      class="sepreator"
    >&nbsp;/&nbsp;</span>
    <span
      ref="pathName"
      class="path-name"
      :title="getCurrentPath"
      :index="getIndex"
    >{{ getCurrentPath }}</span>
  </div>
</template>

<script>
export default {
  name: 'CrumbItem',
  props: {
    itemData: Object,
    index: Number | String,
    widthRate: Number,
    crumbWidth: Number,
    crumbLen: Number,
    isShowlist: Boolean,
    itemMaxWidth: Number,
    itemOffset: 0,
    widerThanParent: Boolean,
  },
  data() {
    return {
      itemStyle: Object,
      originWidth: Number,
    }
  },
  computed: {
    // 是否最后一个
    isLast() {
      if (this.crumbLen === 0) return this.isRoot
      return this.crumbLen === this.index + 1
    },
    // 获取index
    getIndex() {
      if (this.isRoot) return 0
      return +this.index + (this.itemOffset || 0) + 1
    },
    // 是否根目录u
    isRoot() {
      if (!this.itemData) return false
      // root目录第一次拿到的是''所以要在这里处理
      if (!this.originWidth) {
        this.$nextTick(() => {
          this.originWidth = this.$refs.pathName.offsetWidth
        })
      }
      return this.itemData.path.indexOf('/') < 0
    },
    // 获取当前路径名
    getCurrentPath() {
      const param = this.$route.params || {}
      const { neid } = param
      const idx = this.itemData.path.lastIndexOf('/')
      if (idx <= 0) {
        if (this.isRoot) {
          if (neid && neid.length > 32) {
            return ''
          }else {
            return this.itemData.path.substring(0)
          }
        }
        return this.itemData.path.substring(1)
      }
      return this.itemData.path.substring(idx + 1)
    },
  },
  watch: {
    widerThanParent: {
      handler() {
        this.setItemStyle()
      },
      immediate: true,
    },
    widthRate: {
      handler() {
        this.setItemStyle()
      },
      immediate: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      // console.log(this.$refs.sepreator, this.$refs.pathName, this.$refs.pathName.offsetWidth)
      if (this.$refs.pathName) {
        this.originWidth = this.$refs.pathName.offsetWidth
        if (this.$refs.sepreator) {
          this.originWidth += this.$refs.sepreator.offsetWidth
        }
      }
    })
  },
  methods: {
    // 设置item样式
    setItemStyle() {
      this.$nextTick(() => {
        let maxWidth = 0
        if (!this.isShowlist) {
          maxWidth = Math.floor(this.originWidth / this.widthRate)
        }
        if (!this.widerThanParent) {
          // 长度相等得时候也会...
          maxWidth = this.originWidth + 1
        }
        if (this.widerThanParent && this.isShowlist) {
          maxWidth = this.itemMaxWidth
        }
        if (maxWidth > 0) {
          this.itemStyle = {
            'max-width': `${maxWidth}px`,
          }
        }
      })
    },
  },
}
</script>

<style lang="less">

</style>
